export default "__VITE_ASSET__DALRafBk__"